<template>
	<div ref="timer" class="timer" :class="{ 'timer--hidden': hidden }">
		<strong v-if="title" class="timer__title">{{ title }}</strong>
		<div ref="timerNumber" class="timer__number"></div>
		<svg class="timer__svg" viewBox="0 0 100 100">
			<circle class="timer__fixed-layout" r="48" cx="50" cy="50"></circle>
			<circle
				ref="animation"
				class="timer__svg__animation"
				r="48"
				cx="50"
				cy="50"
			></circle>
		</svg>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue'

// Emits
const emit = defineEmits(['time-over'])
// Props
const { seconds } = defineProps({
	seconds: {
		type: Number,
		default: 60
	},

	title: {
		type: String,
		default: 'Resend code in'
	},

	hidden: {
		type: Boolean,
		default: false
	}
})
// Refs
const timer = ref(null)
const timerNumber = ref(null)
const animation = ref(null)
// Hooks
onMounted(() => countDownInit())
const getTimer = () => {
	return Number(window.localStorage.getItem('resentTimer'))
}

const setTimer = value => {
	window.localStorage.setItem('resentTimer', value)
}
const countDownInit = () => {
	const timer = getTimer()
	setTimer(timer || seconds)
	const countdownNumberEl = timerNumber.value

	if (!timer && timer !== 0) {
		setTimer(seconds)
	} else if (timer <= 0) {
		emit('time-over')

		return
	}

	countdownNumberEl && (countdownNumberEl.textContent = getTimer().toString())
	const countdownEl = animation.value
	if (countdownEl) {
		countdownEl.style.strokeDashoffset = (60 + getTimer()) * 5
	}

	const interval = setInterval(function() {
		let currentTime = getTimer()
		setTimer(--currentTime <= 0 ? 0 : currentTime)
		countdownNumberEl && (countdownNumberEl.textContent = getTimer().toString())

		if (countdownEl) {
			//stroke radius length
			countdownEl.style.strokeDashoffset = (seconds + getTimer()) * 5
		}

		if (getTimer() <= 0) {
			clearInterval(interval)
			emit('time-over')
		}
	}, 1000)
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.timer {
	position: relative;
	width: 115px;
	height: 115px;
	visibility: visible;
	opacity: 1;
	margin: 40px auto 25px;
	text-align: center;
	transform: scale(1);
	transition: opacity 0.3s, visibility 0.3s, height 0.3s, width 0.3s,
		margin 0.3s, transform;

	&--hidden {
		visibility: hidden;
	}

	&__title {
		position: absolute;
		width: 100%;
		top: -30px;
		left: 50%;
		transform: translateX(-50%);
		color: $grey;
		font-weight: 300;
		font-size: 16px;
		line-height: 22px;
		white-space: nowrap;
	}

	&__number {
		position: absolute;
		top: 40%;
		left: 50%;
		display: inline-block;
		transform: translate(-50%, -50%);
		font-size: 42px;
		line-height: 40px;
		color: $semi-dark-blue;
		stroke-dashoffset: 600;

		&:after {
			content: 'seconds';
			position: absolute;
			left: 50%;
			bottom: -18px;
			transform: translateX(-50%);
			font-weight: 300;
			font-size: 12px;
			line-height: 12px;
			color: $grey;
		}
	}

	&__svg {
		position: absolute;
		top: 0;
		right: 0;
		width: 115px;
		height: 115px;
		transform: rotateY(-180deg) rotateZ(-90deg);

		&__animation {
			stroke-dasharray: 301;
			stroke-dashoffset: 301;
			stroke-linecap: round;
			stroke: $semi-dark-blue;
			stroke-width: 1px;
			fill: none;
			transition: stroke-dashoffset 1s linear;
		}
	}

	&__fixed-layout {
		stroke: transparent;
		fill: none;
		stroke-width: 1px;
	}
}
</style>
